import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliNotification } from '@lili/lili-frontend-common';
import { PARAMS, TEXT } from './constants';
import { useStore } from '../../store';
import { ReactComponent as ClockIcon } from '../../assets/icons/svg/colored-icons/ic-colored-clock-v2.svg';

const { HEADING } = TEXT;
const { ONE_MINUTE_IN_SECONDS, DISMISS_TIME_MINUTE } = PARAMS;

export const TokenExpired = () => {
  const { t } = useTranslation();
  const setTokenExpired = useStore(state => state.setTokenStatus);
  const handleReLogin = () => {
    setTokenExpired(false);
  };
  setTimeout(() => {
    setTokenExpired(false);
  }, DISMISS_TIME_MINUTE * ONE_MINUTE_IN_SECONDS);

  console.log(handleReLogin);

  return (
    <div
      className='absolute shadow-bottomShadow translate-x-[-50%] top-0 left-[50%] w-[480px]flex justify-center items-center z-50 animate-slideDown'
    >
      <LiliNotification
        onClose={handleReLogin}
        customIcon={<ClockIcon />}
        id='informational-notification'
        text={t(HEADING)}
        type={4}
      />
    </div>
  );
};
